module.exports = {
  BREADCRUMB: {
    PROJECT_ALL: "PROJECT_ALL",
    PROJECT_SELECT: "PROJECT_SELECT",
    ALL: "All",
    CREATE: "Create",
    EDIT: "Edit"
  },
  UPLOAD: {
    MAX_FILE_SIZE_10MB: 10,
    MAX_FILE_SIZE_MB: 1,
    MAX_FILE_SIZE_B: 1048576
  }
};
